import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://girfqqrrzermtlxveatk.supabase.co'
const supabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdpcmZxcXJyemVybXRseHZlYXRrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM4NTQ4NjIsImV4cCI6MjA4OTQzMDg2Mn0.ycn4CblxCMGi3kSRjwOzFOBaJBpxwpM3h77OILIlPjY'

export const SUPABASE_URL = supabaseUrl
export const SUPABASE_ANON_KEY = supabaseAnonKey
export const CURRENT_SUPABASE_URL = supabaseUrl
export const CURRENT_KEY_TYPE = 'LEGACY_ANON_PUBLIC_FORCED'
export const CURRENT_CLIENT_VERSION = 'LOGIN-FIX-2026-04-04-V3'
export const supabase = createClient(supabaseUrl, supabaseAnonKey)
